"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderingSetoid = {
    equals: function (a) { return function (b) {
        return a === b;
    }; }
};
exports.orderingSemigroup = {
    concat: function (a) { return function (b) { return (a === 'LT' || a === 'GT' ? a : b); }; }
};
exports.invert = function (O) {
    if (O === 'LT') {
        return 'GT';
    }
    if (O === 'GT') {
        return 'LT';
    }
    return 'EQ';
};
//# sourceMappingURL=Ordering.js.map